// extracted by mini-css-extract-plugin
export default {"root":"CashflowForecastTable_root__8eQJp","total":"CashflowForecastTable_total__dnQY9","success":"CashflowForecastTable_success__-9gKJ","icon":"CashflowForecastTable_icon__0pkKa"};